import script from "./EducationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EducationView.vue?vue&type=script&lang=ts&setup=true"

import "./EducationView.vue?vue&type=style&index=0&id=389fe4c0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389fe4c0"]])

export default __exports__